import React from "react";
import ReactIframeResizer from "react-iframe-resizer-super";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: theme.spacing(0, 10),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 2)
    }
  },
  iframe: {
    border: "none",
    height: 700
  }
}));

const SurveyIframe = () => {
  // eslint-disable-line
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <ReactIframeResizer
        iframeResizerUrl={false}
        iframeResizerOptions={{
          checkOrigin: false
        }}
        src="/survey.html"
        className={classes.iframe}
      />
    </div>
  );
};

export default SurveyIframe;
